import type { FormState } from 'vee-validate';
import type { Customer } from './modules/useCustomer';

export enum PaymentMethod {
  BANK_DEPOSIT = 'BANK_DEPOSIT',
  BANK_TRANSFER = 'BANK_TRANSFER',
  CARD = 'CARD',
  INSTANT_BANK_TRANSFER = 'INSTANT_BANK_TRANSFER',
}

export type Hash = string;
export type ServiceInternalName = string;
export type PickupPlace = {
  id: number;
  name: string;
  price?: number;
};
export type TimeUntilReservationEnds = number | null;

export interface TripBaseInfo {
  id: string;
  tripDateId: string;
  date: string;
  url: string;
  name: string;
  image: string;
  tripDate: {
    id: number;
    capacity: number;
    duration: number;
    enable_seat_reservations: boolean;
    seating_plan: SeatingPlan;
    start_date: string;
    end_date: string;
  };
}

export interface PaymentMethodObject {
  name: string;
  slug: string;
  description?: string;
}

export interface Price {
  category: string;
  age_range: string | null;
  formatted_price: string;
  id: number;
  pricable_id: number;
  pricable_type: string;
  price: number;
  title: string;
  zlavomat_product_id: string | null;
}

export interface Service {
  internal_name: ServiceInternalName;
  is_billed_per_day: boolean;
  name: string;
  price: number;
  description?: string;
  reservation_image?: string;
}

export type TravellerService = Omit<Service, 'reservation_image'> & {
  price: Price;
};

export interface Traveller {
  birthdate: string;
  first_name: string;
  id_card: string;
  hash: Hash;
  last_name: string;
  pickup_place: number | undefined;
  price?: Price;
  services: {
    [key: ServiceInternalName]: TravellerService;
  };
  // arrayOfServices: string[];
  address_street?: string;
  address_post_code?: string;
  address_country?: string;
  address_city?: string;
}

export interface Reservation extends CustomReservationProps {
  customer: Customer;
  finish_until: string;
  guest_reservation: boolean;
  id: string | null;
  key: string;
  password: string | null;
  requested_travellers_count: number;
  services: Service[];
  travellers:
    | {
        [key: Hash]: Traveller;
      }
    | [];
  trip_id: number;
  trip_duration: number;
  trip_date_id: number;
  vouchers: Voucher[];
}

export interface CustomReservationProps {
  payment_method: string | null;
  newsletter_subscribe?: boolean;
  terms?: boolean;
  note?: string;
}

export interface Voucher {
  code: string;
  amount: number;
}

export enum SeatType {
  Available = 'Available',
  Occupied = 'Occupied',
  Placeholder = 'Placeholder',
  Selected = 'Selected',
}

export enum SeatStatus {
  Available = 'AVAILABLE',
  Blocked = 'BLOCKED',
  Selected = 'SELECTED',
}

export enum SeatingPlan {
  Setra48 = 'setra_48',
  Setra49 = 'setra_49',
  Mercedes53 = 'mercedes_53',
  Mercedes51 = 'mercedes_51',
  Scania63 = 'scania_63',
}

export type FormSlot = FormState<any>;

export interface FieldSlot<V = any> {
  field: {
    name: string;
    onBlur: (e: Event) => void;
    onInput: (e: Event | unknown) => void;
    onChange: (e: Event | unknown) => void;
    'onUpdate:modelValue'?: ((e: V) => unknown) | undefined;
    value?: V;
    checked?: boolean;
  };
  errorMessage?: string;
  value: string | number;
}
